
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  subnav: true,
  maxTocLevel: 4,
  layout: 'reference',
  secondLevelToc: true,
  alwaysExpand: true,
  parentTocLevel: 3,
  childTocLevel: 4,
  description: 'API reference for endpoints and webhooks associated with the Plaid Transactions product.',
  source: 'endpoint'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Callout = makeShortcode("Callout");
const Schema = makeShortcode("Schema");
const MDXCodeBlock = makeShortcode("MDXCodeBlock");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Transactions' subtitle='API reference for Transactions endpoints and webhooks' compact mdxType="Header" />
    <p>{`Retrieve and refresh up to 24 months of historical transaction data, including geolocation, merchant, and category information. For how-to guidance, see the `}<a parentName="p" {...{
        "href": "/docs/transactions/"
      }}>{`Transactions documentation`}</a>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Endpoints`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/transactions/sync`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Get transaction data or incremental transaction updates`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/transactions/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch transaction data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/transactions/recurring/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch recurring transaction data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/transactions/refresh`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Refresh transaction data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/categories/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(Deprecated) Fetch all legacy transaction categories`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`See also`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/transactions/sync`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Get transaction data or incremental transaction updates`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/transactions/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch transaction data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/transactions/recurring/get`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Fetch recurring transaction data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/processor/transactions/refresh`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Refresh transaction data`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`/sandbox/transactions/create`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create custom transactions for testing`}</td>
        </tr>
      </tbody>
    </table>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Webhooks`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#sync_updates_available"
            }}><inlineCode parentName="a">{`SYNC_UPDATES_AVAILABLE`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`New updates available`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#recurring_transactions_update"
            }}><inlineCode parentName="a">{`RECURRING_TRANSACTIONS_UPDATE`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`New recurring updates available`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#initial_update"
            }}><inlineCode parentName="a">{`INITIAL_UPDATE`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Initial transactions ready`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#historical_update"
            }}><inlineCode parentName="a">{`HISTORICAL_UPDATE`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Historical transactions ready`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#default_update"
            }}><inlineCode parentName="a">{`DEFAULT_UPDATE`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`New transactions available`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#transactions_removed"
            }}><inlineCode parentName="a">{`TRANSACTIONS_REMOVED`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deleted transactions detected`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "endpoints"
    }}>{`Endpoints`}</h3>
    <h4 {...{
      "id": "transactionssync"
    }}>{`/transactions/sync`}</h4>
    <Callout mdxType="Callout">
      <p>{`If you are migrating to `}<inlineCode parentName="p">{`/transactions/sync`}</inlineCode>{` from an existing `}<inlineCode parentName="p">{`/transactions/get`}</inlineCode>{` integration, also refer to the `}<a parentName="p" {...{
          "href": "/docs/transactions/sync-migration/"
        }}>{`Transactions Sync migration guide`}</a>{`.`}</p>
    </Callout>
    <Schema method='POST' route='/transactions/sync' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/transactions/sync' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`// Provide a cursor from your database if you've previously
// received one for the Item. Leave null if this is your
// first sync call for this Item. The first request will
// return a cursor.
let cursor = database.getLatestCursorOrNull(itemId);

// New transaction updates since "cursor"
let added: Array<Transaction> = [];
let modified: Array<Transaction> = [];
// Removed transaction ids
let removed: Array<RemovedTransaction> = [];
let hasMore = true;

// Iterate through each page of new transaction updates for item
while (hasMore) {
  const request: TransactionsSyncRequest = {
    access_token: accessToken,
    cursor: cursor,
  };
  const response = await client.transactionsSync(request);
  const data = response.data;

  // Add this page of results
  added = added.concat(data.added);
  modified = modified.concat(data.modified);
  removed = removed.concat(data.removed);

  hasMore = data.has_more;

  // Update cursor to the next cursor
  cursor = data.next_cursor;
}

// Persist cursor and updated data
database.applyUpdates(itemId, added, modified, removed, cursor);
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/transactions/sync \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "access_token": String,
  "cursor": String,
  "count": 250
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`# Provide a cursor from your database if you've previously
# received one for the Item. Leave null if this is your
# first sync call for this item. The first request will
# return a cursor.
cursor = database.get_latest_cursor_or_none(item_id)

# New transaction updates since "cursor"
added = []
modified = []
removed = [] # Removed transaction ids
has_more = true

# Iterate through each page of new transaction updates for item
while has_more
  request = Plaid::TransactionsSyncRequest.new(
    {
      access_token: access_token,
      cursor: cursor,
    }
  )

  response = client.transactions_sync(request)

  # Add this page of results
  added += response.added
  modified += response.modified
  removed += response.removed

  has_more = response.has_more

  # Update cursor to the next cursor
  cursor = response.next_cursor
end

# Persist cursor and updated data
database.apply_updates(item_id, added, modified, removed, cursor)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`// Provide a cursor from your database if you've previously
// received one for the item leave null if this is your
// first sync call for this item. The first request will
// return a cursor.
String cursor = database.getLatestCursorOrNull(itemId);

// New transaction updates since "cursor"
List<Transaction> added = new ArrayList<Transaction>();
List<Transaction> modified = new ArrayList<Transaction>();
List<RemovedTransaction> removed = new ArrayList<RemovedTransaction>();
boolean hasMore = true;

// Iterate through each page of new transaction updates for item
while (hasMore) {
  TransactionsSyncRequest request = new TransactionsSyncRequest()
    .accessToken(accessToken)
    .cursor(cursor);

  TransactionsSyncResponse response = plaidClient.transactionsSync(request).execute().body();

  // Add this page of results
  added.addAll(response.getAdded());
  modified.addAll(response.getModified());
  removed.addAll(response.getRemoved());

  hasMore = response.getHasMore();

  // Update cursor to the next cursor
  cursor = response.getNextCursor();
}
// Persist cursor and updated data
database.applyUpdates(itemId, added, modified, removed, cursor);
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`# Provide a cursor from your database if you've previously
# received one for the Item. Leave null if this is your
# first sync call for this Item. The first request will
# return a cursor.
cursor = database.get_latest_cursor_or_none(item_id)

# New transaction updates since "cursor"
added = []
modified = []
removed = [] # Removed transaction ids
has_more = True

# Iterate through each page of new transaction updates for item
while has_more:
  request = TransactionsSyncRequest(
    access_token=access_token,
    cursor=cursor,
  )
  response = plaid_client.transactions_sync(request)

  # Add this page of results
  added.extend(response['added'])
  modified.extend(response['modified'])
  removed.extend(response['removed'])

  has_more = response['has_more']

  # Update cursor to the next cursor
  cursor = response['next_cursor']

# Persist cursor and updated data
database.apply_updates(item_id, added, modified, removed, cursor)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`// Provide a cursor from your database if you've previously
// received one for the Item. Leave null if this is your
// first sync call for this Item. The first request will
// return a cursor.
cursor := database.getLatestCursorOrNil(itemId)

// New transaction updates since "cursor"
var added []plaid.Transaction
var modified []plaid.Transaction
var removed []plaid.RemovedTransaction // Removed transaction ids
hasMore := true

// Iterate through each page of new transaction updates for item
for hasMore {
    request := plaid.NewTransactionsSyncRequest(accessToken)
    if cursor != nil {
        request.SetCursor(*cursor)
    }
    resp, _, err := client.PlaidApi.TransactionsSync(
        ctx,
    ).TransactionsSyncRequest(*request).Execute()

    // Add this page of results
    added = append(added, resp.GetAdded()...)
    modified = append(modified, resp.GetModified()...)
    removed = append(removed, resp.GetRemoved()...)

    hasMore = resp.GetHasMore()

    // Update cursor to the next cursor
    nextCursor := resp.GetNextCursor()
    cursor = &nextCursor
}

// Persist cursor and updated data
database.applyUpdates(itemId, added, modified, removed, cursor)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`// Provide a cursor from your database if you've previously
// received one for the Item. Leave null if this is your
// first sync call for this Item. The first request will
// return a cursor.
cursor := database.getLatestCursorOrNil(itemId)

// New transaction updates since "cursor"
var added []*plaid.Transaction
var modified []*plaid.Transaction
var removed []*plaid.RemovedTransaction // Removed transaction ids
hasMore := true

// Iterate through each page of new transaction updates for item
for hasMore {
    request := &plaid.TransactionsSyncRequest{AccessToken: accessToken}
    if cursor != nil {
        request.Cursor = cursor
    }
    resp, err := client.Transactions.Sync(ctx, request)

    // Add this page of results
    added = append(added, resp.GetAdded()...)
    modified = append(modified, resp.GetModified()...)
    removed = append(removed, resp.GetRemoved()...)

    hasMore = resp.GetHasMore()

    // Update cursor to the next cursor
    nextCursor := resp.GetNextCursor()
    cursor = &nextCursor
}

// Persist cursor and updated data
database.applyUpdates(itemId, added, modified, removed, cursor)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/transactions/sync' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "transactionsget"
    }}>{`/transactions/get`}</h4>
    <Schema method='POST' route='/transactions/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/transactions/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: TransactionsGetRequest = {
  access_token: accessToken,
  start_date: '2018-01-01',
  end_date: '2020-02-01',
};
try {
  const response = await client.transactionsGet(request);
  let transactions = response.data.transactions;
  const total_transactions = response.data.total_transactions;
  // Manipulate the offset parameter to paginate
  // transactions and retrieve all available data
  while (transactions.length < total_transactions) {
    const paginatedRequest: TransactionsGetRequest = {
      access_token: accessToken,
      start_date: '2018-01-01',
      end_date: '2020-02-01',
      options: {
        offset: transactions.length,
      },
    };
    const paginatedResponse = await client.transactionsGet(paginatedRequest);
    transactions = transactions.concat(paginatedResponse.data.transactions);
  }
} catch (err) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/transactions/get \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "access_token": String,
  "start_date": "2018-01-01",
  "end_date": "2018-02-01",
  "options": {
    "count": 250,
    "offset": 100
  }
}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`start_date = (Date.today - 30)
end_date = Date.today
# Pull transactions for a date range
request = Plaid::TransactionsGetRequest.new(
  {
    access_token: access_token,
    start_date: start_date,
    end_date: end_date
  }
)
response = client.transactions_get(request)
transactions = response.transactions

# Manipulate the offset parameter to paginate
# transactions and retrieve all available data
while transactions.length < response.total_transactions
  request = Plaid::TransactionsGetRequest.new(
    {
    access_token: access_token,
    start_date: start_date,
    end_date: end_date,
    options: {
      offset: transactions.length
    }
    }
  )
  response = client.transactions_get(request)
  transactions += response.transactions
end
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`LocalDate startDate = LocalDate.now().minusDays(30);
LocalDate endDate = LocalDate.now();
// Pull transactions for a date range
TransactionsGetRequest request = new TransactionsGetRequest()
  .accessToken(accessToken)
  .startDate(startDate)
  .endDate(endDate);
Response<TransactionsGetResponse> response =
  plaidClient.transactionsGet(request).execute();

List<Transaction> transactions = new ArrayList<Transaction>();
transactions.addAll(response.body().getTransactions());

// Manipulate the offset parameter to paginate
// transactions and retrieve all available data
while (transactions.size() < response.body().getTotalTransactions()) {
  TransactionsGetRequestOptions options = new TransactionsGetRequestOptions()
    .offset(transactions.size());
  request = new TransactionsGetRequest()
    .accessToken(accessToken)
    .startDate(startDate)
    .endDate(endDate)
    .options(options);

  response = plaidClient.transactionsGet(request).execute();
  transactions.addAll(response.body().getTransactions());
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = TransactionsGetRequest(
            access_token=access_token,
            start_date=datetime.date(2020, 1, 1),
            end_date=datetime.date(2021, 2, 1)
)
response = client.transactions_get(request)
transactions = response['transactions']

# Manipulate the count and offset parameters to paginate
# transactions and retrieve all available data
while len(transactions) < response['total_transactions']:
  request = TransactionsGetRequest(
              access_token=access_token,
              start_date=datetime.date(2020, 1, 1),
              end_date=datetime.date(2021, 2, 1),
              options=TransactionsGetRequestOptions(
                offset=len(transactions)
              )
  )
  response = client.transactions_get(request)
  transactions.extend(response['transactions'])
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`const iso8601TimeFormat = "2006-01-02"
startDate := time.Now().Add(-365 * 24 * time.Hour).Format(iso8601TimeFormat)
endDate := time.Now().Format(iso8601TimeFormat)

request := plaid.NewTransactionsGetRequest(
  accessToken,
  startDate,
  endDate,
)

options := plaid.NewTransactionsGetRequestOptions()
options.SetCount(100)
options.SetOffset(0)

request.SetOptions(*options)

transactionsResp, _, err := client.PlaidApi.TransactionsGet(ctx).TransactionsGetRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`startDate := time.Now().Add(-365 * 24 * time.Hour)
endDate := time.Now()

request := &plaid.TransactionsGetRequest{
    AccessToken: accessToken,
    StartDate:   startDate,
    EndDate:     endDate,
}

options := &plaid.TransactionsGetRequestOptions{}
options.Count = plaid.Int(100)
options.Offset = plaid.Int(0)

request.Options = options

transactionsResp, err := client.Transactions.Get(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/transactions/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "transactionsrecurringget"
    }}>{`/transactions/recurring/get`}</h4>
    <Schema method='POST' route='/transactions/recurring/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/transactions/recurring/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/transactions/recurring/get \\
-H 'Content-Type: application/json' \\
-d '{
     "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
     "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
     "access_token":"access-production-12345678-1234-abcd-9c8f-fd5406010eee",
     "account_ids":[
        "iRMxGT59gs5zPcE8yoHrUb0kU33jo899RCEyw",
        "4fPFAM3KDA2bi0ctj8SYX0KgwJQGx8A2Y6OLP",
        "kYcHNDmCoBDwIyD2ssgwTcZOASdvZZRjIg6I6"
     ]
    }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: TransactionsRecurringGetRequest = {
  access_token: accessToken,
  account_ids: accountIds,
};
try {
  const response = await client.transactionsRecurringGet(request);
  let inflowStreams = response.data.inflow_streams;
  let outflowStreams = response.data.outflow_streams;
} catch (err) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = TransactionsRecurringGetRequest(
  access_token=access_token,
  account_ids=account_ids
)
response = client.transactions_recurring_get(request)
inflow_streams = response.inflow_streams
outflow_streams = response.outflow_streams
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::TransactionsRecurringGetRequest.new(
  {
    access_token: access_token,
    account_ids: account_ids
  }
)
response = client.transactions_recurring_get(request)
inflow_streams = response.inflow_streams
outflow_streams = response.outflow_streams
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`TransactionsRecurringGetRequest request = new TransactionsRecurringGetRequest()
  .accessToken(accessToken)
  .accountIds(accountIds);

Response<TransactionsRecurringGetResponse>
  response = plaidClient.transactionsRecurringGet(request).execute();

List<TransactionStream> inflowStreams = new ArrayList <TransactionStream>();
inflowStreams.addAll(response.body().getInflowStreams());
List<TransactionStream> outflowStreams = new ArrayList <TransactionStream>();
outflowStreams.addAll(response.body().getOutflowStreams());
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewTransactionsRecurringGetRequest(accessToken)
request.SetAccountIds(accountIds)
response, _, err := client.PlaidApi.TransactionsRecurringGet(ctx).TransactionsRecurringGetRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.TransactionsRecurringGetRequest{AccessToken: accessToken}
request.AccountIDs = accountIds
response, err := client.Transactions.GetRecurring(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/transactions/recurring/get' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "transactionsrefresh"
    }}>{`/transactions/refresh`}</h4>
    <Schema method='POST' route='/transactions/refresh' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/transactions/refresh' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/transactions/refresh \\
 -H 'content-type: application/json' \\
 -d '{
   "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
   "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
   "access_token": String,
  }'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`const request: TransactionsRefreshRequest = {
  access_token: accessToken,
};
try {
  await plaidClient.transactionsRefresh(request);
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`request = Plaid::TransactionsRefreshRequest.new({ access_token: access_token })
response = client.transactions_refresh(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`TransactionsRefreshRequest request = new TransactionsRefreshRequest()
  .accessToken(accessToken);
Response<TransactionsRefreshResponse> response = client()
  .transactionsRefresh(request)
  .execute();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`request = TransactionsRefreshRequest(access_token=access_token)
response = client.transactions_refresh(request)
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`request := plaid.NewTransactionsRefreshRequest(accessToken)
response, _, err := client.PlaidApi.TransactionsRefresh(ctx).TransactionsRefreshRequest(*request).Execute()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`request := &plaid.TransactionsRefreshRequest{AccessToken: accessToken}
response, err := client.Transactions.Refresh(ctx, request)
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/transactions/refresh' type='response' mdxType="Schema" />
    <h4 {...{
      "id": "categoriesget"
    }}>{`/categories/get`}</h4>
    <Schema method='POST' route='/categories/get' type='request' mdxType="Schema">
      <MDXCodeBlock type='server' title='/categories/get' mdxType="MDXCodeBlock">
        <pre><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`curl -X POST https://sandbox.plaid.com/categories/get \\
  -H 'Content-Type: application/json' \\
  -d '{}'
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-node"
          }}>{`try {
  const response = await plaidClient.categoriesGet({});
  const categories = response.data.categories;
} catch (error) {
  // handle error
}
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-python"
          }}>{`response = client.categories_get({})
categories = response['categories']
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-java"
          }}>{`Response<CategoriesGetResponse> response = client().categoriesGet(new Object()).execute();
List<Category> categories =
  response.body().getCategories();
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-ruby"
          }}>{`response = client.categories_get({})
categories = response.categories
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go"
          }}>{`categoriesGetResp, _, err := client.PlaidApi.CategoriesGet(ctx).Body(nil).Execute()

categories := categoriesGetResp.GetCategories()
`}</code></pre>
        <pre><code parentName="pre" {...{
            "className": "language-go",
            "metastring": "sdk=fern",
            "sdk": "fern"
          }}>{`categoriesGetResp, err := client.Categories.Get(ctx, nil)

categories := categoriesGetResp.GetCategories()
`}</code></pre>
      </MDXCodeBlock>
    </Schema>
    <Schema method='POST' route='/categories/get' type='response' mdxType="Schema" />
    <h3 {...{
      "id": "webhooks"
    }}>{`Webhooks`}</h3>
    <p>{`You can receive notifications via a webhook whenever there are new transactions associated with an Item, including when Plaid's initial and historical transaction pull are completed. All webhooks related to transactions have a `}<inlineCode parentName="p">{`webhook_type`}</inlineCode>{` of `}<inlineCode parentName="p">{`TRANSACTIONS`}</inlineCode>{`.`}</p>
    <h4 {...{
      "id": "sync_updates_available"
    }}><inlineCode parentName="h4">{`SYNC_UPDATES_AVAILABLE`}</inlineCode></h4>
    <Schema type='model' model='SyncUpdatesAvailableWebhook' mdxType="Schema" />
    <h4 {...{
      "id": "recurring_transactions_update"
    }}><inlineCode parentName="h4">{`RECURRING_TRANSACTIONS_UPDATE`}</inlineCode></h4>
    <Schema type='model' model='RecurringTransactionsUpdateWebhook' mdxType="Schema" />
    <h4 {...{
      "id": "initial_update"
    }}><inlineCode parentName="h4">{`INITIAL_UPDATE`}</inlineCode></h4>
    <Schema type='model' model='InitialUpdateWebhook' mdxType="Schema" />
    <h4 {...{
      "id": "historical_update"
    }}><inlineCode parentName="h4">{`HISTORICAL_UPDATE`}</inlineCode></h4>
    <Schema type='model' model='HistoricalUpdateWebhook' mdxType="Schema" />
    <h4 {...{
      "id": "default_update"
    }}><inlineCode parentName="h4">{`DEFAULT_UPDATE`}</inlineCode></h4>
    <Schema type='model' model='DefaultUpdateWebhook' mdxType="Schema" />
    <h4 {...{
      "id": "transactions_removed"
    }}><inlineCode parentName="h4">{`TRANSACTIONS_REMOVED`}</inlineCode></h4>
    <Schema type='model' model='TransactionsRemovedWebhook' mdxType="Schema" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "endpoints",
        level: 3,
        title: "Endpoints",
      },
{
        id: "transactionssync",
        level: 4,
        title: "/transactions/sync",
      },
{
        id: "transactionsget",
        level: 4,
        title: "/transactions/get",
      },
{
        id: "transactionsrecurringget",
        level: 4,
        title: "/transactions/recurring/get",
      },
{
        id: "transactionsrefresh",
        level: 4,
        title: "/transactions/refresh",
      },
{
        id: "categoriesget",
        level: 4,
        title: "/categories/get",
      },
{
        id: "webhooks",
        level: 3,
        title: "Webhooks",
      },
{
        id: "sync_updates_available",
        level: 4,
        title: "SYNC_UPDATES_AVAILABLE",
      },
{
        id: "recurring_transactions_update",
        level: 4,
        title: "RECURRING_TRANSACTIONS_UPDATE",
      },
{
        id: "initial_update",
        level: 4,
        title: "INITIAL_UPDATE",
      },
{
        id: "historical_update",
        level: 4,
        title: "HISTORICAL_UPDATE",
      },
{
        id: "default_update",
        level: 4,
        title: "DEFAULT_UPDATE",
      },
{
        id: "transactions_removed",
        level: 4,
        title: "TRANSACTIONS_REMOVED",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
